import { RouteConfig } from 'vue-router';


const Account = () => import(/* webpackChunkName:"Main" */ '../account/account.vue');
const ExportResults = () => import(/* webpackChunkName:"Main" */ './views/export-results/export-results.vue');
const Sjzx = () => import(/* webpackChunkName:"Sjzx" */ '../shujuzhongxin/sjzx.vue');
const Zbsjk = () => import(/* webpackChunkName:"Zbsjk" */ '../shujuzhongxin/zbsjk/zbsjk.vue');
const Tongue = () => import(/* webpackChunkName:"Tongue" */ '../shujuyanjiu/tongue/tongue.vue');
const Dig = () => import(/* webpackChunkName:"Zbsjk" */ '../dig/dig.vue');
const Yhqx = () => import(/* webpackChunkName:"Yhqx" */ '../yonghuquanxian/yhqx.vue');
const Home = () => import(/* webpackChunkName:"Home" */ '../home/home.vue');

import AccountRouters from "../account/account.router";
import SjzxRouters from "../shujuzhongxin/sjzx.router";
import ZbsjkRouters from "../shujuzhongxin/zbsjk/zbsjk.router";
import TonguekRouters from "../shujuyanjiu/tongue/tongue.router";
import DigRouters from "../dig/dig.router";
import YhqxRouters from "../yonghuquanxian/yhqx.router";
import HomeRouters from "../home/home.router";

const routers: RouteConfig[] = [
    {
        path: 'export-results',
        component: ExportResults,

    },
    {
        path: 'home',
        component: Home,
        children: HomeRouters,

    },
    {
        path: 'sjzx',
        component: Sjzx,
        children: SjzxRouters,

    },
    {
        path: 'zbsjk',
        component: Zbsjk,
        children: ZbsjkRouters,

    },
    {
        path: 'tongue',
        component: Tongue,
        children: TonguekRouters,

    },
    {
        path: 'dig',
        component: Dig,
        children: DigRouters,

    },
    {
        path: 'yhqx',
        component: Yhqx,
        children: YhqxRouters,

    },
    {
        path: 'account',
        component: Account,
        children: AccountRouters
    },
    {
        path: '',
        redirect: 'account'
    },
];

export default routers;
